import { get } from "@/apis";
import message from "ant-design-vue/lib/message";

export default {
  namespaced: true,
  state: {
    IsRenderingCompleted: false, // 是否渲染完成

    IsRenderConfigCompleted: false, // 配置是否加载完成
    // 活动信息
    doings: {
      id: 0,
      alias: 0,
      activityId: 0,
      name: "",
      rule: null,
      beginTime: "",
      endTime: "",
      limitMode: "",
      limitCount: 0,
      promptSettings: null,
      banner: "",
      footer: "",
      status: "",
    },
    // 门禁点详细配置
    config: {
      id: 0,
      ruleId: 0,
      accessControlName: "",
      accessControlMode: undefined,
      alias: 0,
      activityId: 0,
      limitMode: undefined,
      limitCount: undefined,
      accountName: "",
      phone: "",
    },
  },
  mutations: {
    SET_DOINGS(state, payload) {
      state.doings = payload;
    },
    SET_CONFIG(state, payload) {
      state.config = payload;
    },
    SET_RENDER_CONFIG_COMPLETED(state, payload) {
      state.IsRenderConfigCompleted = payload;
    },
    SET_ACCESS_CONTROLER_RENDERING_COMPLETED(state, payload) {
      state.IsRenderingCompleted = payload;
    },
  },
  getters: {
    getDoings: (state) => {
      return state.doings;
    },
    getConfig: (state) => {
      return state.config;
    },
    getIsRenderConfigCompleted: (state) => {
      return state.IsRenderConfigCompleted;
    },
    accessControlerRenderingCompleted: (state) => {
      return state.IsRenderingCompleted;
    },
  },
  actions: {
    async setDoings(context, data) {
      message.open({
        content: "背景加载中...",
        type: "loading",
        duration: 1,
      });

      const { alias } = data;
      const res = await get(
        `/api/AccessControl/GetAccessControlConfigByAlias/${alias}`
      );
      if ((res.code = 200 && res.success)) {
        context.commit("SET_DOINGS", res.data);
      }
    },
    async setConfig(context, data) {
      message.open({
        content: "配置加载中...",
        type: "loading",
        duration: 1,
      });

      const { pointId } = data;
      const res = await get(
        `/api/AccessControl/GetAccessControlPointConfig/${pointId}`
      );
      if ((res.code = 200 && res.success)) {
        context.commit("SET_CONFIG", res.data);
      }
    },
    setRenderConfigCompleted(context, data) {
      context.commit("SET_RENDER_CONFIG_COMPLETED", data);
    },
    setIsAccessControlerRenderingCompleted(context) {
      context.commit("SET_ACCESS_CONTROLER_RENDERING_COMPLETED", true);
    },
  },
};
